// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"215":"910912fe","872":"d1c82d1c"}[chunkId] + ".css";
};